import 'isomorphic-fetch';
import config from '../config';
import {objectToParams} from '../helpers';

export function getGuestToken(params) {
  if (!params.token) {
    const apiToken = JSON.parse(localStorage.getItem('mhdApiToken'));
    if (apiToken && !(new Date(apiToken.expiration) < new Date(Date.now()))) {
      const payload = JSON.parse(
        atob(apiToken.token.access_token.split('.')[1]),
      );
      return Promise.resolve({...apiToken.token, tokenData: payload});
    } else {
      return Promise.reject(new Error('Missing authentication token'));
    }
  }

  if (localStorage.getItem('mhdApiToken') !== null) {
    localStorage.removeItem('mhdApiToken');
  }

  const req = {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    body: objectToParams({
      client_id: config.identity.client_id,
      client_secret: config.identity.client_secret,
      grant_type: 'guest_access',
      scope: 'guest_access',
      token: params.token,
    }),
  };

  return fetch(`${config.identity.url}/connect/token`, req)
    .then(res => {
      return res.json().then(token => {
        if (token.error) {
          throw new Error(token.error);
        }
        if (res.status >= 400) {
          throw new Error(`Unknown Error ${res.status}`);
        }
        const expiration = new Date(
          new Date(Date.now()).getTime() + token.expires_in * 1000,
        );
        // when we stop storing guest token in local storage, yggy can be updated to not get guest token from header and use the cookie like everywhere else
        localStorage.setItem(
          'mhdApiToken',
          JSON.stringify({token: {...token, isGuest: true}, expiration}),
        );
        return token;
      });
    })
    .then(token => {
      const payload = JSON.parse(atob(token.access_token.split('.')[1]));
      return {...token, tokenData: payload};
    });
}



// WEBPACK FOOTER //
// ./src/paymentApp/authenticate.js